import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import api from "../Api";
import TableFooter from "../components/TableFooter";
// import { Link } from "react-router-dom";
import Popup from "../components/PopUP";
import { useNavigate } from "react-router-dom";
import UserDeactivateModal from "../components/UserDeactivateModal";
import UserActivateModal from "../components/UserActivateModal";
import {IMAGE_URL} from "../utils/constants";


export default function UserManagement() {
  const navigate = useNavigate();
  const [users, setUsers] = useState({})
  const [loading, setLoading] = useState(true);
  const [popupMessage, setPopupMessage] = useState("");
  const [pagination, setPagination] = useState({
    count: 0,
    total_pages: 0,
    next: 0,
    previous: 0
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [query, setQuery] = useState("")
  useEffect(() => {
    if (loading === false) {
      setPopupMessage("Users loaded successfully")
    }
    // else{
    //     setPopupMessage("Users loading  please wait ...")
    // }
  }, [loading])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get("/user-service/user/all?page=" + currentPage + "&q=" + query);
        console.log(response.data)
        setUsers(response.data)
        setPagination({
          count: response.data.count,
          total_pages: response.data.total_pages,
          next: response.data.next,
          previous: response.data.previous
        });
      } catch (error) {
        console.error("API Error:", error.message);
        // setPopupMessage("Something went wrong please")
      }

      setLoading(false)
    };

    fetchData();
  }, [currentPage, query, loading])

  const [showModal, setShowModal] = useState(false);
  const [showActiveModal, setActiveShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleConfirmDeactivation = async (reason) => {
    console.log("deactivation:", selectedItem.user_id);
    setLoading(true)
    try {
      const response = await api.patch('/user-service/user/status', {
        "user_id": selectedItem.user_id,
        "action": "deactivate",
        "reason": reason?.trim() || ""
      })
      console.log("Activation response:", response.data);
      setPopupMessage("User deactivated successfully")
      setSelectedItem(null);
    }
    catch (error) {
      console.log("Activation error:", error);
      setPopupMessage("An error occurred during deactivation")
    }
    setShowModal(false);
    setLoading(false);
  };

  const handleConfirmActivation = async (reason) => {
    console.log("activating:", selectedItem.user_id);
    setLoading(true);
    try {
      const response = await api.patch('/user-service/user/status', {
        "user_id": selectedItem.user_id,
        "action": "activate",
        "reason": reason?.trim() || ""
      })
      console.log("Activation response:", response.data);
      setPopupMessage("User activated successfully")
    }
    catch (error) {
      console.log("Activation error:", error);
      setPopupMessage("Unable to avtivate user please try again.")
    }
    setActiveShowModal(false);
    setSelectedItem(null);
    setLoading(false);
  };


  const handleDeactivateClick = (item) => {
    console.log("Item to delete:", item);
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleActivateClick = (item) => {
    console.log("Item to delete:", item);
    setSelectedItem(item);
    setActiveShowModal(true);
  };


  const goToUser = (id) => {
    navigate(`/user/${id}`);
  };

  console.log("currentPage: ", currentPage)

  return (
    <div className="user-management-page">
      <Popup message={popupMessage} onClose={() => setPopupMessage("")} />
      {/* Sidebar */}
      <Sidebar />

      {/* Main Wrapper */}
      <div className="main-wrapper">
        {/* Header */}
        <Header />

        {/* Content Section */}
        <div className="content-wrapper">
          <section className="main-section spacer-y">
            <div className="container">
              <div className="row gy-4">
                <div className="col-xl-12">
                  <div className="common_main_bg_wrapper">
                    <div className="common_main_heading_wrapper">
                      <div className="vstack">
                        <h1>User Management</h1>
                      </div>
                    </div>
                  </div>

                  {/* Table */}
                  {loading ? 
                   <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                  :
                    <div className="common-table-wrapper mt-4">
                      <div className="common-table-filter-wrapper">
                        <div className="common-left-blk">
                          <div className="common_sub_heading_wrapper mb-0">
                            <h2>User Listing</h2>
                          </div>
                        </div>
                        <div className="common-right-blk">
                          <div className="common-sort-blk">
                            <div className="common-search-blk">
                              <input type="search" className="form-control" id="search" value={query} placeholder="Search" onChange={(e) => setQuery(e.target.value)} name="user_search" />
                            </div>
                          </div>
                          {/* <button className="filter_action_btn cal_btn">Jun 18, 2025 - Jun 23, 2025</button> */}
                        </div>
                      </div>

                      <div className="table-blk table-responsive">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>S.No.</th>
                              <th>Name</th>
                              <th>Email Address</th>
                              <th> Date Joined  </th>
                              <th>User Role</th>
                              <th>Active</th>
                              <th>Subscription</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {users.results && users.results.map((user, index) => (
                              <tr key={user.id}>
                              <td>{(index + 1) + (currentPage - 1) * 20}</td>
                                <td className="text-capitalize">{user.first_name || user.last_name ?<>{user.first_name} {user.last_name}</>:<>_</>} </td>
                                <td className="email_td">{user.email}</td>
                                <td>{user.created_at}</td>
                                <td className="text-uppercase">{user.user_type}</td>
                                <td>{user.is_active ? <span className="badge bg-light text-success">Active</span> :
                                  <span className="badge bg-light text-danger">Deactivate</span>}</td>
                                <td>{user.is_active_subscription ? <span className="badge bg-light text-success">Active</span> :
                                  <span className="badge bg-light text-danger">Deactivate</span>}</td>
                                <td>
                                  <button onClick={() => goToUser(user.id)} className="border-0 bg-white">
                                    <img src={IMAGE_URL+"eye-tbl-icon.svg"} alt="View" />
                                  </button>
                                  {user.is_active ?
                                    <button
                                      className="border-0 bg-white"
                                      onClick={() => handleDeactivateClick({ "user_id": user.id, "name": user.first_name + " " + user.last_name })}
                                    >
                                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" className="bi bi-toggle-off ms-1"
                                        viewBox="0 0 16 16">
                                        <path
                                          d="M11 4a4 4 0 0 1 0 8H8a5 5 0 0 0 2-4 5 5 0 0 0-2-4zm-6 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8M0 8a5 5 0 0 0 5 5h6a5 5 0 0 0 0-10H5a5 5 0 0 0-5 5" />
                                      </svg>
                                    </button>
                                    :
                                    <button
                                      className="border-0 bg-white ms-1"
                                      onClick={() => handleActivateClick({ "user_id": user.id, "name": user.first_name + " " + user.last_name })}
                                    >
                                      <svg xmlns="http://www.w3.org/2000/svg"
                                        width="26" height="26" fill="currentColor" className="bi bi-toggle-on"
                                        viewBox="0 0 16 16">
                                        <path d="M5 3a5 5 0 0 0 0 10h6a5 5 0 0 0 0-10zm6 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8" />
                                      </svg>
                                    </button>
                                  }

                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* footer */}
                      <TableFooter
                        pagination={pagination}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                      {/*  */}
                    </div>
                  }
                  {/* Table End */}
                  {/* Delete Modal */}
                  <UserDeactivateModal
                    show={showModal}
                    onClose={() => setShowModal(false)}
                    onConfirm={handleConfirmDeactivation}
                    itemName={selectedItem ? selectedItem.name : ""}
                  />
                  <UserActivateModal
                    show={showActiveModal}
                    onClose={() => setActiveShowModal(false)}
                    onConfirm={handleConfirmActivation}
                    itemName={selectedItem ? selectedItem.name : ""}
                  />
                  {/*  */}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
